var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6254 2.78395C5.16093 2.94945 4.79308 3.31599 4.62328 3.78251L1.77785 11.6003C1.46518 12.4593 1.90016 13.4063 2.7494 13.7154L8.13127 15.6742C8.98051 15.9833 9.92242 15.5375 10.2351 14.6785L13.0805 6.86069C13.2503 6.39417 13.2041 5.87694 12.9547 5.4516L11.0744 2.24509C10.6786 1.57013 9.86399 1.27365 9.12693 1.53628L5.6254 2.78395ZM8.27098 6.91766C8.90791 7.14948 9.61434 6.81512 9.84883 6.17084C10.0833 5.52656 9.7571 4.81634 9.12017 4.58452C8.48324 4.3527 7.77681 4.68706 7.54232 5.33134C7.30782 5.97562 7.63405 6.68584 8.27098 6.91766Z",
    fill: "#2D3958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusive);
export default __webpack_public_path__ + "static/media/exclusive.5af9621d3ddc48e4ba67559b03354323.svg";
export { ForwardRef as ReactComponent };